
export function HomeGlobalStagingContent() {
    
    return (<>
    <div>HomeGlobalStagingContent</div>
    </>)
}